import { defineComponent as _defineComponent } from 'vue'
import { useListeners } from 'vue';
import { Tag } from '@/interfaces/model/general/tag';


export default /*#__PURE__*/_defineComponent({
  __name: 'TagChip',
  props: {
    tag: null,
    isLabel: { type: Boolean },
    addClass: null,
    icon: null
  },
  emits: ["closeEvent", "clickEvent"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'closeEvent'): void;
  (e: 'clickEvent'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  tag?: Tag;
  isLabel?: boolean;
  addClass?: string;
  icon?: string;
};





const listeners = useListeners();
const hasCloseEvent = !!listeners.closeEvent;
const hasClickEvent = !!listeners.clickEvent;

const tagColorStyles = (
  colorCodeTypeNum: number
): { backgroundColor: string; textColor: string } => {
  let colorCode: string;

  switch (colorCodeTypeNum) {
    case 1:
      colorCode = '244,67,54';
      break;
    case 2:
      colorCode = '233,30,99';
      break;
    case 3:
      colorCode = '156,39,176';
      break;
    case 4:
      colorCode = '103,58,183';
      break;
    case 5:
      colorCode = '63,81,181';
      break;
    case 6:
      colorCode = '25,118,210';
      break;
    case 7:
      colorCode = '2,136,209';
      break;
    case 8:
      colorCode = '0,131,143';
      break;
    case 9:
      colorCode = '0,121,107';
      break;
    case 10:
      colorCode = '46,125,50';
      break;
    case 11:
      colorCode = '104,159,56';
      break;
    case 12:
      colorCode = '175,180,43';
      break;
    case 13:
      colorCode = '253,216,53';
      break;
    case 14:
      colorCode = '255,179,0';
      break;
    case 15:
      colorCode = '245,124,0';
      break;
    case 16:
      colorCode = '255,87,34';
      break;
    case 17:
      colorCode = '121,85,72';
      break;
    case 18:
      colorCode = '96,125,139';
      break;
    case 0:
      // Gray color for "No tags" option
      colorCode = '158,158,158';
      break;
    default:
      colorCode = '0,150,136';
  }

  return {
    backgroundColor: `rgba(${colorCode}, 0.24)`,
    textColor: `rgb(${colorCode})`,
  };
};

return { __sfc: true,props, emits, listeners, hasCloseEvent, hasClickEvent, tagColorStyles }
}

})